import { BaseRequest, PagingRequest } from 'Services/base';
import {
  ListFinancialAccountsResponse,
} from './interfaces';
import { getQueryParamsForListAPI } from 'Services/api';

const FINANCIAL_ACCOUNTS_BASE_URL = '/accountingservice/v1/financial-accounts';

export class ListFinancialAccountsRequest extends BaseRequest<ListFinancialAccountsResponse> {
  constructor(
    paging: PagingRequest,
  ) {
    super( {
      method: 'GET',
      url: FINANCIAL_ACCOUNTS_BASE_URL,
      responseType: 'json',
      params: getQueryParamsForListAPI( paging ),
    } );
  }
}

